import { Button, Divider, Form, Input, Select, Space } from 'antd'
import { useEffect, useState } from 'react'
import React from 'react'

import { MinusCircle, PlusSquare } from '@phosphor-icons/react'
import { PublisherService } from '@services/PublisherService'

import type { Curriculum, Publisher, WebLink } from '../../../../types'

export type BundleFieldType = {
    name: string
    description: string
    order: number
    meta?: {
        links: WebLink[]
    }
    curriculumIds: string[]
    creatorId: string
}

type BundleFormProps = {
    title: string
    initialValues?: BundleFieldType
    onFinish: (values: BundleFieldType) => void
    onCancel: () => void
    curriculums?: Curriculum[]
}

const defaultFormItemLayout = {
    labelCol: {
        xs: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 12 }
    }
}

export const BundleForm = ({ title, initialValues, onFinish, onCancel, curriculums }: BundleFormProps) => {
    const [form] = Form.useForm()
    const [publishers, setPublishers] = useState<Publisher[]>()

    useEffect(() => {
        const fetch = async () => {
            const results = await PublisherService.list()
            setPublishers(results)
        }

        fetch()
    }, [])

    return (
        <Form form={form} {...defaultFormItemLayout} disabled={false} onFinish={onFinish}>
            <h3>{title}</h3>
            <Form.Item
                label="Name"
                name="name"
                initialValue={initialValues?.name}
                rules={[{ required: true, message: 'Please enter a name' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                {...defaultFormItemLayout}
                label="Description"
                name="description"
                initialValue={initialValues?.description}
                rules={[{ required: true, message: 'Please enter a description' }]}
            >
                <Input.TextArea />
            </Form.Item>
            {publishers && (
                <Form.Item name="creatorId" label="Creator" initialValue={initialValues?.creatorId}>
                    <Select>
                        {publishers.map(p => (
                            <Select.Option key={p.creatorId} value={p.creatorId}>
                                {p.creator?.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            )}

            <Divider dashed>Links</Divider>

            <Form.Item
                label="Order"
                name="order"
                initialValue={initialValues?.order}
                rules={[{ required: true, message: 'Please enter a name' }]}
            >
                <Input type="number" />
            </Form.Item>

            <Form.List name={['meta', 'links']} initialValue={initialValues?.meta?.links}>
                {(fields, { add, remove }) => (
                    <div style={{ textAlign: 'center' }}>
                        {fields.map(({ key, name, ...restField }) => (
                            <React.Fragment key={key}>
                                <Form.Item
                                    {...restField}
                                    label="Name"
                                    name={[name, 'name']}
                                    rules={[{ required: true }]}
                                >
                                    <Input placeholder="Name" />
                                </Form.Item>

                                <Form.Item
                                    {...restField}
                                    label="Url"
                                    name={[name, 'url']}
                                    rules={[{ required: true, type: 'url' }]}
                                >
                                    <Input placeholder="Url" />
                                </Form.Item>
                                <Button
                                    danger
                                    className="dynamic-delete-button"
                                    onClick={() => remove(name)}
                                    icon={<MinusCircle />}
                                >
                                    Remove Above Field
                                </Button>
                                <Divider />
                            </React.Fragment>
                        ))}
                        <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusSquare />}
                            style={{ width: '150px' }}
                        >
                            Add link
                        </Button>
                    </div>
                )}
            </Form.List>

            {curriculums && (
                <Form.Item name="curriculumIds" label="Curriculums" initialValue={initialValues?.curriculumIds}>
                    <Select mode="multiple">
                        {curriculums.map(c => (
                            <Select.Option key={c.id} value={c.id}>
                                {c.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            )}
            <Divider />

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Space>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    )
}
